import { render } from "./CouponItem.vue?vue&type=template&id=0b808e7e&scoped=true"
import script from "./CouponItem.vue?vue&type=script&lang=js"
export * from "./CouponItem.vue?vue&type=script&lang=js"

import "./CouponItem.vue?vue&type=style&index=0&id=0b808e7e&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b808e7e"]])

export default __exports__